import { render } from "./ReplicaStudio.vue?vue&type=template&id=8012beb0&scoped=true"
import script from "./ReplicaStudio.vue?vue&type=script&lang=js"
export * from "./ReplicaStudio.vue?vue&type=script&lang=js"

import "./ReplicaStudio.vue?vue&type=style&index=0&id=8012beb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8012beb0"]])

export default __exports__